module.exports = __webpack_public_path__ + "static/media/noImage.1d107182.jpg";